
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CheckLegalInformationRequest,
  ClientCompanyBillingInformationResource,
  ClientCompanyBillingInformationUpdateRequest,
  CompanyLegalInformation,
  LegalInformationProvider,
  LegalInformationSearchResponse,
  ManualLegalVerificationSource,
  SuggestedPrimaryIdentifierResource,
  ValidateRegistrationVatConsistencyRequest,
  ValidateRegistrationVatConsistencyResponse,
} from '../models';
import {
    CheckLegalInformationRequestFromJSON,
    CheckLegalInformationRequestToJSON,
    ClientCompanyBillingInformationResourceFromJSON,
    ClientCompanyBillingInformationResourceToJSON,
    ClientCompanyBillingInformationUpdateRequestFromJSON,
    ClientCompanyBillingInformationUpdateRequestToJSON,
    CompanyLegalInformationFromJSON,
    CompanyLegalInformationToJSON,
    LegalInformationProviderFromJSON,
    LegalInformationProviderToJSON,
    LegalInformationSearchResponseFromJSON,
    LegalInformationSearchResponseToJSON,
    ManualLegalVerificationSourceFromJSON,
    ManualLegalVerificationSourceToJSON,
    SuggestedPrimaryIdentifierResourceFromJSON,
    SuggestedPrimaryIdentifierResourceToJSON,
    ValidateRegistrationVatConsistencyRequestFromJSON,
    ValidateRegistrationVatConsistencyRequestToJSON,
    ValidateRegistrationVatConsistencyResponseFromJSON,
    ValidateRegistrationVatConsistencyResponseToJSON,
} from '../models';

export interface CheckLegalInformationOperationRequest {
    checkLegalInformationRequest: CheckLegalInformationRequest;
}

export interface FetchLegalInformationFromProviderRequest {
    provider: LegalInformationProvider;
    externalId: string;
    registrationNumber: string;
    countryCode: string;
    hqRegistrationCity?: string;
}

export interface GetCompanyBillingInformationRequest {
    companyId: string;
}

export interface GetSuggestedPrimaryIdentifierRequest {
    registrationNumber: string;
    countryCode: string;
    registrationOfficeInformation?: string;
}

export interface ManuallyVerifyLegalEntityRequest {
    companyId: string;
    source: ManualLegalVerificationSource;
    primaryIdentifierType: string;
    primaryIdentifierValue: string;
    url?: string | null;
    file?: Blob | null;
}

export interface SearchRequest {
    query: string;
}

export interface UpdateCompanyBillingInformationRequest {
    companyId: string;
    clientCompanyBillingInformationUpdateRequest: ClientCompanyBillingInformationUpdateRequest;
}

export interface ValidateRegistrationVatConsistencyOperationRequest {
    validateRegistrationVatConsistencyRequest: ValidateRegistrationVatConsistencyRequest;
}

/**
 * 
 */
export class ClientCompanyBillingInformationApi extends runtime.BaseAPI {

    /**
     * Check the billing information verification status
          */
    async checkLegalInformationRaw(requestParameters: CheckLegalInformationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['checkLegalInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'checkLegalInformationRequest',
                'Required parameter "checkLegalInformationRequest" was null or undefined when calling checkLegalInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/legal-information/check-legal-information`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckLegalInformationRequestToJSON(requestParameters['checkLegalInformationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Check the billing information verification status
          */
    async checkLegalInformation(requestParameters: CheckLegalInformationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.checkLegalInformationRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch legal information
          */
    async fetchLegalInformationFromProviderRaw(requestParameters: FetchLegalInformationFromProviderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanyLegalInformation>> {
        if (requestParameters['provider'] == null) {
            throw new runtime.RequiredError(
                'provider',
                'Required parameter "provider" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        if (requestParameters['registrationNumber'] == null) {
            throw new runtime.RequiredError(
                'registrationNumber',
                'Required parameter "registrationNumber" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling fetchLegalInformationFromProvider().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['externalId'] != null) {
            queryParameters['externalId'] = requestParameters['externalId'];
        }

        if (requestParameters['registrationNumber'] != null) {
            queryParameters['registrationNumber'] = requestParameters['registrationNumber'];
        }

        if (requestParameters['hqRegistrationCity'] != null) {
            queryParameters['hqRegistrationCity'] = requestParameters['hqRegistrationCity'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanyLegalInformation>({
            path: `/compliance/api/legal-information/fetch-client-legal-information`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanyLegalInformationFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch legal information
          */
    async fetchLegalInformationFromProvider(requestParameters: FetchLegalInformationFromProviderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanyLegalInformation> {
        const response = await this.fetchLegalInformationFromProviderRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getCompanyBillingInformationRaw(requestParameters: GetCompanyBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyBillingInformationResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompanyBillingInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanyBillingInformationResource>({
            path: `/compliance/api/client-company-billing-information/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyBillingInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCompanyBillingInformation(requestParameters: GetCompanyBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyBillingInformationResource> {
        const response = await this.getCompanyBillingInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the suggested primary identifier type and value for manual verification
          */
    async getSuggestedPrimaryIdentifierRaw(requestParameters: GetSuggestedPrimaryIdentifierRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SuggestedPrimaryIdentifierResource>> {
        if (requestParameters['registrationNumber'] == null) {
            throw new runtime.RequiredError(
                'registrationNumber',
                'Required parameter "registrationNumber" was null or undefined when calling getSuggestedPrimaryIdentifier().'
            );
        }

        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getSuggestedPrimaryIdentifier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['registrationNumber'] != null) {
            queryParameters['registrationNumber'] = requestParameters['registrationNumber'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['registrationOfficeInformation'] != null) {
            queryParameters['registrationOfficeInformation'] = requestParameters['registrationOfficeInformation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SuggestedPrimaryIdentifierResource>({
            path: `/compliance/api/client-company-billing-information/manual-verification/suggested-primary-identifier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SuggestedPrimaryIdentifierResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the suggested primary identifier type and value for manual verification
          */
    async getSuggestedPrimaryIdentifier(requestParameters: GetSuggestedPrimaryIdentifierRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SuggestedPrimaryIdentifierResource> {
        const response = await this.getSuggestedPrimaryIdentifierRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Manually verify a client legal entity
          */
    async manuallyVerifyLegalEntityRaw(requestParameters: ManuallyVerifyLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        if (requestParameters['source'] == null) {
            throw new runtime.RequiredError(
                'source',
                'Required parameter "source" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        if (requestParameters['primaryIdentifierType'] == null) {
            throw new runtime.RequiredError(
                'primaryIdentifierType',
                'Required parameter "primaryIdentifierType" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        if (requestParameters['primaryIdentifierValue'] == null) {
            throw new runtime.RequiredError(
                'primaryIdentifierValue',
                'Required parameter "primaryIdentifierValue" was null or undefined when calling manuallyVerifyLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['source'] != null) {
            formParams.append('source', new Blob([JSON.stringify(ManualLegalVerificationSourceToJSON(requestParameters['source']))], { type: "application/json", }));
                    }

        if (requestParameters['url'] != null) {
            formParams.append('url', requestParameters['url'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['primaryIdentifierType'] != null) {
            formParams.append('primaryIdentifierType', requestParameters['primaryIdentifierType'] as any);
        }

        if (requestParameters['primaryIdentifierValue'] != null) {
            formParams.append('primaryIdentifierValue', requestParameters['primaryIdentifierValue'] as any);
        }

        const response = await this.request<void>({
            path: `/compliance/api/client-company-billing-information/{companyId}/manual-verification`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return response;
    }

    /**
     * Manually verify a client legal entity
          */
    async manuallyVerifyLegalEntity(requestParameters: ManuallyVerifyLegalEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.manuallyVerifyLegalEntityRaw(requestParameters, initOverrides);
    }

    /**
     * Search for company legal information
          */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<LegalInformationSearchResponse>>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling search().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<LegalInformationSearchResponse>>({
            path: `/compliance/api/legal-information/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(LegalInformationSearchResponseFromJSON);
        return response;
    }

    /**
     * Search for company legal information
          */
    async search(requestParameters: SearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<LegalInformationSearchResponse>> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateCompanyBillingInformationRaw(requestParameters: UpdateCompanyBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanyBillingInformationResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateCompanyBillingInformation().'
            );
        }

        if (requestParameters['clientCompanyBillingInformationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyBillingInformationUpdateRequest',
                'Required parameter "clientCompanyBillingInformationUpdateRequest" was null or undefined when calling updateCompanyBillingInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientCompanyBillingInformationResource>({
            path: `/compliance/api/client-company-billing-information/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyBillingInformationUpdateRequestToJSON(requestParameters['clientCompanyBillingInformationUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientCompanyBillingInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateCompanyBillingInformation(requestParameters: UpdateCompanyBillingInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanyBillingInformationResource> {
        const response = await this.updateCompanyBillingInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Validate that a registration number and VAT number belong to the same company
          */
    async validateRegistrationVatConsistencyRaw(requestParameters: ValidateRegistrationVatConsistencyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ValidateRegistrationVatConsistencyResponse>> {
        if (requestParameters['validateRegistrationVatConsistencyRequest'] == null) {
            throw new runtime.RequiredError(
                'validateRegistrationVatConsistencyRequest',
                'Required parameter "validateRegistrationVatConsistencyRequest" was null or undefined when calling validateRegistrationVatConsistency().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ValidateRegistrationVatConsistencyResponse>({
            path: `/compliance/api/legal-information/validate-reg-vat-consistency`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateRegistrationVatConsistencyRequestToJSON(requestParameters['validateRegistrationVatConsistencyRequest']),
        }, initOverrides);

        if (response._data) { response._data=ValidateRegistrationVatConsistencyResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Validate that a registration number and VAT number belong to the same company
          */
    async validateRegistrationVatConsistency(requestParameters: ValidateRegistrationVatConsistencyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ValidateRegistrationVatConsistencyResponse> {
        const response = await this.validateRegistrationVatConsistencyRaw(requestParameters, initOverrides);
        return response._data;
    }

}
